import "./Style.scss";
import UserManagement from "./UserManagement";

export { UserManagement };
